/**
 * 将 group 名称转换为中文说明
 * 
 * 规则：
 * - {systemName}-owners → {systemName}所有者
 * - {systemName}-viewers → {systemName}只读
 * - system-manager → 系统管理员
 * - 其他：保持原样
 */
export function getTeamDisplayName(groupName: string): string {
  // system-manager 特殊处理
  if (groupName === 'system-manager') {
    return '系统管理员';
  }

  // 处理 -owners 结尾
  if (groupName.endsWith('-owners')) {
    const systemName = groupName.replace(/-owners$/, '');
    return `${systemName}所有者`;
  }

  // 处理 -viewers 结尾
  if (groupName.endsWith('-viewers')) {
    const systemName = groupName.replace(/-viewers$/, '');
    return `${systemName}只读`;
  }

  // 其他情况保持原样
  return groupName;
}

/**
 * 检查 group 是否应该显示在团队管理页面
 * 
 * 规则：
 * - 名称以 -owners 结尾
 * - 名称以 -viewers 结尾
 * - 名称等于 system-manager
 */
export function isTeamGroup(groupName: string): boolean {
  return (
    groupName === 'system-manager' ||
    groupName.endsWith('-owners') ||
    groupName.endsWith('-viewers')
  );
}

